export default (object, comparator = (item => !item)) => {
  if (object === null || typeof object !== 'object') {
    // eslint-disable-next-line no-console
    return console.warn('You must pass object to "checkEveryObjectValue" function!');
  }
  return Object.values(object).every(comparator);
};
